import { gql } from '@apollo/client';
import {
  CommonLocalizableString,
  CommonLocalizableVideo,
  CommonLocalizableImage,
  CommonLocalizableFile,
  NonQuestionContentElement,
} from 'network/common/cmsFragment';
import { fetchAllPage } from 'network/common/cmsUtils';

const fetchBoothTabByIdQuery = gql`
  query fetchBoothTabByIdQuery(
    $id: ID!
    $locales: [Locale!]!
    $cursor: String
    $count: Int
  ) {
    node(id: $id) {
      ... on BoothTabContentElement {
        id
        title {
          ...CommonLocalizableString
        }
        masterElement {
          ... on BoothTabMasterElement {
            masterControlledBody
          }
        }
        body(first: $count, after: $cursor) {
          pageInfo {
            hasNextPage
            endCursor
          }
          nodes {
            __typename
            id
            ...NonQuestionContentElement
            ... on BoothQuestionContentElement {
              question {
                ...CommonLocalizableString
              }
              answer {
                ...NonQuestionContentElement
              }
            }
          }
        }
      }
    }
  }
  ${CommonLocalizableString}
  ${CommonLocalizableVideo}
  ${CommonLocalizableImage}
  ${CommonLocalizableFile}
  ${NonQuestionContentElement}
`;

interface FetchBoothTabByIdQueryProps {
  tabId: string;
  locales: string[];
  count?: number;
}

const fetchBoothTabById = async (config: FetchBoothTabByIdQueryProps) => {
  const pages = await fetchAllPage(
    (data: any) => data.node.body.pageInfo,
    fetchBoothTabByIdQuery,
    { ...config, count: config.count || 20, id: config.tabId },
  );

  const tabContentElements = pages
    .flatMap((page) => page.node.body.nodes);

  const { node: { id, title, masterElement } } = pages[0];

  const result = {
    id,
    title,
    masterElement,
    body: tabContentElements,
  };

  return result;
};

export default fetchBoothTabById;
